import { createFileRoute } from '@tanstack/react-router'
import { Login } from '@/components/auth/Login'
import Header from '@/components/Header'
import Logo from '@/components/Logo'
import OpenClawIcon from '@/assets/openclaw-color.svg?react'
import OpenClawText from '@/assets/openclaw-text.svg?react'

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === 'string' ? search.from : undefined,
  }),
  staticData: {
    title: 'Log In — PhoneSalad',
    description: 'Log in to your PhoneSalad account to make affordable international calls to 200+ countries directly from your browser.',
    sitemap: { priority: '0.4', changefreq: 'yearly' },
  },
  component: LoginPage,
})

function OpenClawContext() {
  return (
    <div className="mb-6 text-center space-y-4">
      <div className="flex items-center justify-center gap-3">
        <div className="flex items-center gap-1.5">
          <OpenClawIcon className="w-6 h-6" />
          <OpenClawText className="h-4 text-foreground" />
        </div>
        <span className="text-muted-foreground font-medium text-sm">x</span>
        <Logo size="sm" linkTo="" />
      </div>
      <p className="text-sm text-muted-foreground max-w-xs mx-auto">
        Sign in to finish setting up voice calls for your OpenClaw agent. It only takes a moment.
      </p>
    </div>
  )
}

function LoginPage() {
  const { from } = Route.useSearch()

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {from === 'openclaw' && <OpenClawContext />}
          <Login />
        </div>
      </main>
    </div>
  )
}
